import axios from 'axios';
import { useQuery } from 'react-query';
import { MAKE_MODELS } from './constants';
import getBaseApi from '@luna-protocol/core/src/utils/getBaseApi';

export interface MakeModelsRes {
  make_models: MakeModel[];
}

export interface MakeModel {
  make: string;
  model: string;
  oemName: string;
  year: number;
  msrp: number;
}

const getMakeModels = async (product_type?: string) => {
  const params = product_type ? { product_type } : undefined;
  const resp = await axios.get(`${getBaseApi()}/dealer/make_models`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('user_token')}`,
    },
    params,
  });
  if (resp.status !== 200) {
    throw new Error('Failed to get make models');
  }
  return resp.data as MakeModelsRes;
};

const useGetMakeModels = (product_type?: string) => {
  return useQuery([MAKE_MODELS, product_type], async () => {
    return await getMakeModels(product_type);
  });
};

export { useGetMakeModels };
